const API_PREFIX = '/api/v1'
const ENVIORNMENT = 'development'
const ZERO = 0
const ONE = 1
const TWO = 2
const THREE = 3
const GET_REQUEST = 'get'
const POST_REQUEST = 'post'
const PATCH_REQUEST = 'patch'
const BOOLEAN_TRUE = true
const BOOLEAN_FALSE = false
const NULL = null
const EMPTY_STRING = ''
const REQUESTED_RECORD = 10
const CENTS = 100
const STATUS_401 = 401
const STATUS_200 = 200
const LOGOUT = '/logout'
// const S3_BASE_URL = 'https://test.workupdates.online/'
const S3_BASE_URL = 'https://hireavendor.co.za/'

// * api end point URL
const VERIFY_OTP_END_POINT = '/admin/verify-otp'
const SEND_OTP_END_POINT = '/admin/login'
const LOGOUT_END_POINT = '/admin/logout'
const ALL_VENDOR_END_POINT = '/admin/vendors'
const ALL_SERVICE_END_POINT = '/admin/services'
const ALL_TAGS_END_POINT = '/admin/tags'
const ALL_INFO_END_POINT = '/admin/info-pages'
const ALL_SOCIAL_END_POINT = '/admin/social-media'
const FETCH_SEO_END_POINT = '/admin/fetch-seo'
const UPDATE_SEO_END_POINT = '/admin/update-seo'
const RESEND_OTP_END_POINT = '/admin/resend-otp'
const ALL_VENDORS_END_POINT = '/admin/vendors'
const VIEW_VENDORS_END_POINT = '/admin/vendor'
const CREATE_VENDORS_END_POINT = '/admin/create-vendor'
const UPDATE_VENDOR_END_POINT = '/admin/update-vendor'
const FETCH_PROFILE_END_POINT = '/admin/fetch-profile'
const UPDATE_PROFILE_END_POINT = '/admin/update-profile'
const CHANGE_PASSWORD_END_POINT = '/admin/change-password' 
const GET_SERVICE_END_POINT = '/get-services' 
const GER_TAG_END_POINT = '/get-tags' 
const VENDOR_STATUS_END_POINT = '/admin/update-vendor-status' 
const MOBILE_BAR_QUOTATION_END_POINT = '/admin/mobile-bar-quotations' 
const UPDATE_MOBILE_BAR_QUOTATION_END_POINT = '/admin/update-mobile-bar-quotations' 
const CATERER_QUOTATION_END_POINT = '/admin/caterer-quotations' 
const UPDATE_CATERER_QUOTATION_END_POINT = '/admin/update-caterer-quotations' 
const DELETE_MOBILE_QUOTATION_END_POINT = '/admin/delete-mobile-quote' 
const DELETE_CATERER_QUOTATION_END_POINT = '/admin/delete-catering-quote' 
const DELETE_VENDOR_END_POINT = '/admin/vendor-delete' 
const DELETE_VENDOR_IMAGE_END_POINT = '/admin/vendor-image-delete' 
const DASHBOARD_END_POINT = '/admin/dashboard' 
const SITE_SETTING_END_POINT = '/admin/fetch-site-setting' 
const UPDATE_SITE_SETTING_END_POINT = '/admin/update-site-setting' 
const FORGOT_PASSWORD_END_POINT = '/admin/forget-password' 
const FORGOT_VERIFY_OTP_END_POINT = '/admin/forget-verify-otp' 
const RESET_PASSWORD_END_POINT = '/admin/reset-password' 
const QUOTATION_STATUS_END_POINT = '/admin/status-quotation-update' 
const DELETE_SERVICE_IMAGE_END_POINT = '/admin/image-delete-vendor-service' 


module.exports = { 
    //* api end points
    DELETE_SERVICE_IMAGE_END_POINT,
    QUOTATION_STATUS_END_POINT,
    RESET_PASSWORD_END_POINT,
    FORGOT_VERIFY_OTP_END_POINT,
    FORGOT_PASSWORD_END_POINT,
    UPDATE_SITE_SETTING_END_POINT,
    SITE_SETTING_END_POINT,
    DELETE_VENDOR_IMAGE_END_POINT,
    DASHBOARD_END_POINT,
    DELETE_VENDOR_END_POINT,
    DELETE_CATERER_QUOTATION_END_POINT,
    UPDATE_CATERER_QUOTATION_END_POINT,
    DELETE_MOBILE_QUOTATION_END_POINT,
    CATERER_QUOTATION_END_POINT,
    UPDATE_MOBILE_BAR_QUOTATION_END_POINT,
    MOBILE_BAR_QUOTATION_END_POINT,
    VENDOR_STATUS_END_POINT,
    GER_TAG_END_POINT,
    GET_SERVICE_END_POINT,
    CHANGE_PASSWORD_END_POINT,
    UPDATE_PROFILE_END_POINT,
    FETCH_PROFILE_END_POINT,
    CREATE_VENDORS_END_POINT,
    UPDATE_VENDOR_END_POINT,
    VIEW_VENDORS_END_POINT,
    ALL_VENDORS_END_POINT,
    RESEND_OTP_END_POINT,
    FETCH_SEO_END_POINT,
    UPDATE_SEO_END_POINT,
    ALL_SOCIAL_END_POINT,
    ALL_INFO_END_POINT,
    ALL_TAGS_END_POINT,
    ALL_SERVICE_END_POINT,
    ALL_VENDOR_END_POINT,
    SEND_OTP_END_POINT,
    VERIFY_OTP_END_POINT,
    LOGOUT_END_POINT, 
    // * veriables
    S3_BASE_URL,
    CENTS, 
    LOGOUT,
    EMPTY_STRING,
    REQUESTED_RECORD,
    API_PREFIX,
    ENVIORNMENT,
    ZERO,
    THREE,
    ONE,
    STATUS_401,
    STATUS_200,
    TWO,
    NULL,
    GET_REQUEST,
    POST_REQUEST,
    PATCH_REQUEST,
    BOOLEAN_TRUE,
    BOOLEAN_FALSE,
}